import {
  createBaseThemeOptions,
  createUnifiedTheme,
  defaultTypography,
} from '@backstage/theme';
import { clrslateDarkPalette, clrslateLightPalette } from './palettes';
import { clrslatePageThemes } from './pageThemes';
import { makeClrslateComponents } from './components';
import { borderColor, fonts, shadows, shadowsDark, tracking } from './tokens';

/** Geist everywhere; headings get the design system's tight tracking + weights. */
const typography = {
  ...defaultTypography,
  fontFamily: fonts.sans,
  h1: { ...defaultTypography.h1, fontWeight: 700, letterSpacing: tracking.tight },
  h2: { ...defaultTypography.h2, fontWeight: 700, letterSpacing: tracking.tight },
  h3: { ...defaultTypography.h3, fontWeight: 600, letterSpacing: tracking.snug },
  h4: { ...defaultTypography.h4, fontWeight: 600, letterSpacing: tracking.snug },
  h5: { ...defaultTypography.h5, fontWeight: 600 },
  h6: { ...defaultTypography.h6, fontWeight: 600 },
};

export const clrslateLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: clrslateLightPalette,
    defaultPageTheme: 'home',
    typography,
  }),
  defaultPageTheme: 'home',
  fontFamily: fonts.sans,
  pageTheme: clrslatePageThemes,
  components: makeClrslateComponents({
    border: borderColor.light,
    shadows: { xs: shadows.xs, sm: shadows.sm },
  }),
});

export const clrslateDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: clrslateDarkPalette,
    defaultPageTheme: 'home',
    typography,
  }),
  defaultPageTheme: 'home',
  fontFamily: fonts.sans,
  pageTheme: clrslatePageThemes,
  components: makeClrslateComponents({
    border: borderColor.dark,
    shadows: { xs: shadowsDark.xs, sm: shadowsDark.sm },
  }),
});
